export enum OperationStatus {
  notStarted = 'notStarted',
  processing = 'processing',
  success = 'success',
  fail = 'fail',
}
